import { TValidationType } from '@r1-frontend/api-domru/phone-validator/validation/dto/TValidationType';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

interface ISend {
    phone: string,
    type: TValidationType,
}

/*
* Отправка запроса на валидацию
* https://master.phone-validator.sandbox.d2c.r-one.io/docs/#/validation/ValidationController_validate
* */
export const send = (queryParams: ISend): IRequest => ({
    uri: '/validation/send',
    method: 'GET',
    queryParams: queryParams,
});
